// extracted by mini-css-extract-plugin
module.exports = {"list":"y7clY","message":"YQxpY","loader":"clcru"};